export default {
  id: 93,
  title: 'Target #93 - Great Wall',
  url: 'https://cssbattle.dev/play/93',
  colors: ['#4F77FF', '#191919', '#F9E492', '#D6B73F'],
  solution:
    '<a a><a b><a c><a d><style>[a],[b]{background:#f9e492}[b],[c]{height:16}body{background:#191919}a{position:fixed}[a]{top:90;left:140;width:40;height:40;border-radius:9in}[b]{top:172;left:0;width:200;box-shadow:0 26px #f9e492,0 52px #f9e492,220px -13px #f9e492,220px 13px #f9e492,220px 39px #f9e492}[c]{top:165;left:200;width:20;background:#d6b73f;transform:skewY(-33deg);box-shadow:0 26px #d6b73f,0 52px #d6b73f}[d]{top:0;left:0;width:400;height:300;background:radial-gradient(circle,transparent,transparent 100px,#4f77ff 100px)}</style>',
}
